import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../redux/connect';
import { closeGallery } from '../redux/actions';
import {
  getCurrentlyViewedAttachmentsWithThumbnails,
  getGallerySelectedIndex,
} from '../redux/selectors';
import { Gallery } from '@adsk/bim360-matrix-react-components';

export class PureIssueAttachmentGallery extends PureComponent {

  render() {
    const { attachments, closeGallery, container, selectedAttachmentIndex } = this.props;

    if (!attachments) {
      return null;
    }

    return (
      <Gallery container={container}
        selectedItem={selectedAttachmentIndex}
        items={attachments}
        onHide={closeGallery}
      />
    );
  }
}

PureIssueAttachmentGallery.displayName = 'IssueAttachmentGallery';

PureIssueAttachmentGallery.propTypes = {
  attachments: PropTypes.array,
  selectedAttachmentIndex: PropTypes.number,
  container: PropTypes.object,
  closeGallery: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  selectedAttachmentIndex: getGallerySelectedIndex(state),
  attachments: getCurrentlyViewedAttachmentsWithThumbnails(state),
});

const mapDispatchToProps = {
  closeGallery,
};

export default connect(mapStateToProps, mapDispatchToProps)(PureIssueAttachmentGallery);
